export class MarginInfoParameters {
}
